import { useState, useEffect } from 'react';
import '../css/forklift.css';
import ForkliftCard from '../components/ForkliftCard';
import MiniForkliftCard from '../components/MiniForkliftCard';
import Ask from "../components/Ask";
import { fetchForklifts } from '../http/forkliftAPI';

const Forklift = () => {
  const [showFullCard, setShowFullCard] = useState(false);
  const [forklifts, setForklifts] = useState([]);
  const [selectedForklift, setSelectedForklift] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);


  useEffect(() => {
    const loadForklifts = async () => {
      try {
        const data = await fetchForklifts();
        setForklifts(data);
        if (data.length > 0) {
          setSelectedForklift(data[0]);
        }
      } catch (err) {
        setError('Ошибка загрузки погрузчиков');
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    loadForklifts();
  }, []);

  if (loading) {
    return <div>Загрузка...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  return (
    <div className="container" style={{ maxWidth: 1200 }}>
      <h1 className="homepage_h1">Погрузчики</h1>
      <p className="homepage_p">
        Мы предлагаем широкий ассортимент погрузчиков различных марок и моделей.
      </p>

      {/* Мини-карточки всех погрузчиков */}
      <div className="d-flex justify-content-center mt-4 gap-4 flex-wrap">
        {forklifts.map((forklift) => (
          <MiniForkliftCard
            key={forklift.id}
            product={{
              id: forklift.id,
              title: forklift.name,
              price: `${forklift.price} ₽ c НДС`,
              img: forklift.img
            }}
            onClick={() => {
              setSelectedForklift(forklift);
              setShowFullCard(true);
            }}
          />
        ))}
      </div>

      {/* Модальное окно с полной карточкой */}
      {showFullCard && selectedForklift && (
        <div className="modal-overlay" onClick={() => setShowFullCard(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="close-btn" onClick={() => setShowFullCard(false)}>×</button>
            <ForkliftCard product={selectedForklift} />
          </div>
        </div>
      )}

      <Ask />
    </div>
  );
};

export default Forklift;